import { ExpressionCondition } from '@/models/audiences';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionCondition } from './ActionCondition';
import { MembershipCondition } from './MembershipCondition';
import { PropertyCondition } from './PropertyCondition';
import { PropertyOperations } from '@/services/endpoints/audiences';

interface IExpressionConditionRenderProps {
  operationList: PropertyOperations;
  expression?: ExpressionCondition;
  onChange?: (Condition: ExpressionCondition) => void;
  isViewMode?: boolean;
  datasourceIds?: string[];
  isTextOnly?: boolean;
}

export const ExpressionConditionRender: FunctionComponent<IExpressionConditionRenderProps> = ({
  expression,
  onChange,
  isViewMode,
  datasourceIds,
  operationList,
}) => {
  const { t } = useTranslation('ALL');

  switch (expression?.type) {
    case 'MEMBERSHIP':
      return <MembershipCondition expression={expression} onChange={(exp) => onChange?.(exp)} isViewMode={isViewMode} />;
    case 'ACTION':
      return <ActionCondition expression={expression} onChange={(exp) => onChange?.(exp)} isViewMode={isViewMode} />;
    case 'PROPERTY':
      return (
        <PropertyCondition
          expression={expression}
          onChange={(exp) => onChange?.(exp)}
          isViewMode={isViewMode}
          datasourceIds={datasourceIds}
          operationList={operationList}
        />
      );
    default:
      return (
        <div className='flex w-full'>
          <p>{t('expressionOfType', { type: expression?.type })}</p>
        </div>
      );
  }
};
